const keyToken = "accessToken";
export function getToken(){
  return sessionStorage.getItem(keyToken);
}

export function setToken(value :any){
  sessionStorage.setItem(keyToken,value)
}

export function clearToken() {
  sessionStorage.setItem(keyToken,"");
}
